<div class="source-media-setting" [ngClass]="{'show-source-media-button': shouldShowSourceMediaButton()}">
	@if (shouldShowSourceTypeDropdown()) {
		<div class="form-group">
			<mat-form-field appearance="outline" class="full-width">
				<mat-label translate="activity-editor-new_source-media"></mat-label>
				<mat-select
					[formControl]="sourceTypeControl"
					(selectionChange)="onSourceTypeChange($event)">
					<mat-select-trigger>
						{{ (getSelectedSourceType()?.title | translate) }}
					</mat-select-trigger>

					@for (sourceType of sourceTypes; track sourceType.title) {
						<mat-option [value]="sourceType.title">
							<strong translate="{{ sourceType.title}}"></strong>
							<p translate="{{ sourceType.description }}"></p>
						</mat-option>
					}
				</mat-select>

				@if (sourceTypeControl.invalid && sourceTypeControl.touched) {
					<mat-error>
						@if (sourceTypeControl.errors?.['required']) {
							<span translate="activity-editor-source-media-required"></span>
						}
					</mat-error>
				}
			</mat-form-field>
		</div>
	}

	@if (shouldShowSourceMediaButton()) {
		<button
			type="button"
			[innerHTML]="'activity-editor-new_source-media-link-button-text' | translate"
			class="link-btn add-btn markers-btn add-source-media-btn"
			(click)="openSourceMediaModal()"
			data-cy="add-comment-source-media"
		></button>
		@if (!sourceMediaControl.value) {
			<mat-error>
				<span translate="activity-editor-source-media-required"></span>
			</mat-error>
		}
	}

	@if (sourceMediaControl.value) {
		<ngx-source-media-panel
			[sourceMedia]="sourceMediaControl.value"
			[groupId]="activity.group_id"
			(onRemove)="handleOnRemoveSourceMedia()"
			(onMediaSync)="handleMediaSync($event)"
		>
		</ngx-source-media-panel>
	}
</div>
